// import React, { Component } from 'react';
import RangePicker from '~/js/components/vendor/react-dates/RangePicker';
import { ANCHOR_LEFT, ANCHOR_RIGHT } from 'react-dates/lib/constants';
import Dropdown from './Dropdown';
import CustomDropdown from './CustomDropdown';

// import Cookie from '~/js/modules/Cookie';

// import './ReactDates/DateRangePicker.scss';
// import './ReactDates/Dropdown.scss';

const { Component, Fragment } = React;

import { countryList, resortList, sandalsList, beachesList } from './data/quick-quote';

export default class QuickQuote extends Component {
  static defaultProps = {
    brand: 'sandals',
    hasCountries: true,
    hasResorts: true,
    anchorDirection: (window.innerWidth < 768) ? ANCHOR_LEFT : ANCHOR_RIGHT,
    className: 'qq',
    controlThemeClassName: '',
    noLabels: false,
    quoteButtonText: 'Rates & Availability',
    quoteButtonClassName: 'dsc-quote-btn',
    reference: 'obe',
    eventID: '',
    groupID: '',
    defaultResortCode: '',
    schedulerModeIndex: 1,
    numberOfMonths: (window.innerHeight > 991) ? 2 : 1,
    resortDisabled: false,
    allowedResortCodes: [],
    hasOccupancy: true,
    occupancyLabels: true,
    noOfAdults: 7,
    noOfChildren: 7,
    startDatePlaceholderText: 'Check-In',
    endDatePlaceholderText: 'Check-Out',
    adultsDropdownPlaceHolder: '',
    childrenDropdownPlaceHolder: '',
    resortLabelText: 'SELECT RESORT',
    notOeeRequest: false,
    resortListBrand: 'beaches',
    confirmationNumber: false,
    // hasCreditLabel: false,
    // hasCreditLabel: 'SAVE $35',
  };

  constructor(props) {
    super(props);

    this.isMobile = window.innerWidth < 768;

    this.DATE_FORMAT = 'MM/DD/YYYY';
    this.bookNowURL = '/book-now/';

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,


      fields: {
        reference: 'obe',

        // Inputs
        startDate: '',
        endDate: '',
        resortCode: '',
        resortCountry: '',
        noOfAdults: 1,
        noOfChildren: 0,

        // OEE
        nights: '',
        eventID: '',
        groupID: '',
        isMobile: false,
        schedulerModeIndex: '',
        check_in_date: '',

        // // Rooms and Suite

        // /bookingengine/?rst_code=seb&room_category=BWV
        // /book-now/?rst_code=seb&room_category=BWV&resortCountry=BS&event=ehOBE.dspHome

        // 'room_category': '', // HSB1B
        // 'resortCountry': '', // JM
        // 'OBE_PARTNER_AGENT_ID': '', // JOSCH2806
        // // rst_code=smb
        // // event=ehOBE.dspHome
      }
    };
  }

  componentDidMount() {
    this._setDefaultValues();
  }

  _setDefaultValues = () => {
    const { ...fields } = this.state.fields;
    const { reference, eventID, groupID, schedulerModeIndex, defaultResortCode, brand, confirmationNumber, notOeeRequest } = this.props;

    if (reference === 'oee') {
      fields.eventID = eventID;
      fields.groupID = groupID;
      fields.schedulerModeIndex = schedulerModeIndex;
      fields.brand = brand;
      fields.notOeeRequest = notOeeRequest;
      fields.confirmation_number = (confirmationNumber) ? -1 : null;
    }

    fields.reference = reference;
    fields.resortCode = defaultResortCode;
    fields.isMobile = this.isMobile;

    this.setState({ fields });
  }

  _toQueryParams = (object) => {
    const keys = Object.keys(object);
    let parameters = '';
    let value;
    let prefix;

    keys.map(key => {
      value = object[key];
      prefix = parameters ? '&' : '?';

      if (value || value === 0) {
        parameters += prefix + key + '=' + encodeURIComponent(value);
      }
    });

    return parameters;
  }

  _generateURL = (fields) => this.bookNowURL + this._toQueryParams(fields);

  // Date Range Picker
  _onDatesChange = ({ startDate, endDate }) => {

    const { ...fields } = this.state.fields;
    const { reference } = this.props;

    fields.startDate = startDate && startDate.clone().format(this.DATE_FORMAT);
    fields.endDate = endDate && endDate.clone().format(this.DATE_FORMAT);

    if (reference === 'oee' && startDate && endDate) {
      fields.nights = endDate.diff(startDate, 'days');
      fields.check_in_date = fields.startDate;
      fields.resort = fields.resortCode;
    }

    this.setState({ startDate, endDate, fields });
  }

  _onFocusChange =(focusedInput) => this.setState({ focusedInput });

  _onInputChange = (event) => {
    const { name, value } = event.target;
    const { ...fields } = this.state.fields;

    if (name === 'noOfAdults') {
      (value === '') ? fields[name] = 1 : fields[name] = value;
    } else if(name === 'noOfChildren') {
      (value === '') ? fields[name] = 0 : fields[name] = value;
    } else {
      fields[name] = value;
    }


    if (name === 'resortCountry') {
      fields.resortCode = null;
    }

    this.setState({ fields });
  }

  _generateOccupancy = (occupancy, isZeroBase = true) => {

    const options = [...Array(occupancy).keys()].map((number) => (<option key={`opt-${(isZeroBase) ? 'children' : 'adult'}-${number}`} value={(isZeroBase ? number : number + 1 )}>{(isZeroBase ? number : number + 1 )}</option>));

    const placeHolder = (this.props.adultsDropdownPlaceHolder.length || this.props.childrenDropdownPlaceHolder.length) ? <option key="default-value-placeholder" value="">Select One</option> : null;

    if ((this.props.adultsDropdownPlaceHolder.length || this.props.childrenDropdownPlaceHolder.length)) {
      return(
        <Fragment>
          {
            [placeHolder, ...options]
          }
        </Fragment>
      );
    }

    return(
      <Fragment>
        {
          [...options]
        }
      </Fragment>
    );
  }

  render() {
    const { fields } = this.state;
    const { resortListBrand, brand, resortDisabled, defaultResortCode, resortsPlaceholder, allowedResortCodes, noOfAdults, noOfChildren, quoteButtonText, resortLabelText } = this.props;
    const { resortCountry } = fields;
    let rstList = sandalsList;
    const url = this._generateURL(fields);

    switch (resortListBrand) {
      case 'all':
        rstList = resortList;
        break;
      case 'beaches':
        rstList = beachesList;
        break;
      default:
        rstList = sandalsList;
        break;
    }

    const filteredResortList = rstList.filter(resort => {

      if (allowedResortCodes.length) {
        return allowedResortCodes.includes(resort.val);
      }

      return !resortCountry || resort.country === resortCountry;
    });

    const rstCountrySet = new Set(rstList.map(resort => resort.country));
    const filteredCountryList = Array.from(rstCountrySet).map(countryCode => countryList.find(country => country.val === countryCode));
    const noOfAdultsOptions = this._generateOccupancy(noOfAdults, false);
    const noOfChildrenOptions = this._generateOccupancy(noOfChildren);

    return (
      <div className={this.props.className}>
        {
          this.props.hasCountries &&
          <div className={`control-wrapper ${ this.props.controlThemeClassName }`}>
            {
              !this.props.noLabels && (
                <label htmlFor="countries">
                  SELECT DESTINATION
                </label>
              )
            }
            <Dropdown
              id="countries"
              inputName="resortCountry"
              defaultOption="Select Destination"
              defaultValue={ this.state.country }
              changeHandler={ this._onInputChange }
              options={ filteredCountryList }
            />
          </div>
        }
        {
          this.props.hasResorts &&
          <div className={`control-wrapper ${ this.props.controlThemeClassName }`}>
            {
              !this.props.noLabels && (
                <label htmlFor="resorts">
                  { resortLabelText }
                </label>
              )
            }
            <Dropdown
              id="resorts"
              wrapperClassName={ resortDisabled ? 'disabled' : '' }
              inputName="resortCode"
              defaultOption={resortsPlaceholder || 'Select Resort'}
              defaultValue={ defaultResortCode }
              changeHandler={ this._onInputChange }
              options={ filteredResortList }
              disabled={ resortDisabled }
            />
          </div>
        }

        <RangePicker
          startDateId="startDate"
          endDateId="endDate"
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          focusedInput={this.state.focusedInput}
          onDatesChange={this._onDatesChange}
          onFocusChange={this._onFocusChange}
          startDateLabelText="CHECK-IN"
          endDateLabelText="CHECK-OUT"
          startDatePlaceholderText={this.props.startDatePlaceholderText}
          endDatePlaceholderText={this.props.endDatePlaceholderText}
          anchorDirection={this.props.anchorDirection}
          noLabels={this.props.noLabels}
          numberOfMonths={(window.innerWidth > 991) ? this.props.numberOfMonths : 1}
          orientation={this.props.orientation}
        />

        {
          this.props.hasOccupancy &&
          <div className={`occupancy-wrapper ${ (this.props.occupancyLabels) ? '' : 'no-labels' }`}>
            <div className={`control-wrapper inline-block occupancy-control adults ${ this.props.controlThemeClassName }`}>
              {
                this.props.occupancyLabels && <label htmlFor="noOfAdults">Adults <span>Age 16+</span></label>
              }
              <CustomDropdown
                inputName="noOfAdults"
                inputId="noOfAdults"
                wrapperClassName="form-control custom-ddl pr inline-block"
                externalChangeHandler={ this._onInputChange }
                placeHolderText={ this.props.adultsDropdownPlaceHolder }
              >
                { noOfAdultsOptions }
              </CustomDropdown>
            </div>
            <div className={`control-wrapper inline-block occupancy-control children ${ this.props.controlThemeClassName }`}>
              {
                this.props.occupancyLabels && <label htmlFor="noOfChildren">Children <span>Age 0-15</span></label>
              }
              <CustomDropdown
                inputName="noOfChildren"
                inputId="noOfChildren"
                wrapperClassName="form-control custom-ddl pr inline-block"
                externalChangeHandler={ this._onInputChange }
                placeHolderText={ this.props.childrenDropdownPlaceHolder }
              >
                { noOfChildrenOptions }
              </CustomDropdown>
            </div>
          </div>
        }

        <a className={ this.props.quoteButtonClassName } href={ url } dangerouslySetInnerHTML={ {__html: quoteButtonText} }/>
      </div>
    );
  }
}
